import React from 'react';
import * as BuilderUI from '../../../../../../../components/Builder/BuilderUI';
import RemoveVariantAction from '../../SignificanceVariants/RemoveVariantAction';
import SignificanceFieldValueMenu from '../../SignificanceFieldValueMenu';
import { useAppSelector } from '../../../../../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  significanceCriteriaSelector,
  significanceErrorSelector,
} from '../../../../../../../redux/selectors/builder';
import VariantLabel from '../../SignificanceVariants/VariantLabel';
import {
  IFieldFieldsFragment,
  QueryType,
  SignificanceModeKey,
} from '../../../../../../../utils/apollo/graphqlSchema';
import {
  assertCondition,
  assertNotNil,
} from '../../../../../../../utils/types';
import { useParentFieldValueFilter } from '../../../../../../../components/ParentFieldValue/utils';

interface IProps {
  field: IFieldFieldsFragment;
  variant: string | null;
  variantIndex: number;
  onChange: (variant: string | null, variantIndex: number) => void;
  onRemove: (variantIndex: number) => void;
  allowRemove: boolean;
}

const SignificanceExperimentVariant = ({
  field,
  variant,
  variantIndex,
  onChange,
  onRemove,
  allowRemove,
}: IProps) => {
  const hasError = useAppSelector((state) =>
    significanceErrorSelector(state, 'criteriaVariant'),
  );

  const defaultOptions = useAppSelector(builderDefaultOptionsSelector);
  const significanceCriteria = useAppSelector(significanceCriteriaSelector);

  assertCondition(
    significanceCriteria?.modeKey === SignificanceModeKey.Experiment &&
      defaultOptions?.type === QueryType.Significance,
  );

  const experimentConfig = defaultOptions.experimentConfig;
  assertNotNil(experimentConfig);
  const { experimentField } = experimentConfig;
  const { experimentId } = significanceCriteria;

  const parentFieldValueFilter = useParentFieldValueFilter(
    field,
    experimentField,
    experimentId,
  );

  return (
    <BuilderUI.BuilderFieldContainer>
      <VariantLabel variantIndex={variantIndex} />
      <SignificanceFieldValueMenu
        field={field}
        value={variant}
        onChange={(value) => onChange(value, variantIndex)}
        placeholder={'Select variant group'}
        hasError={variantIndex === 0 && hasError}
        parentFieldValueFilter={parentFieldValueFilter}
      />
      {allowRemove && (
        <RemoveVariantAction onClick={() => onRemove(variantIndex)} />
      )}
    </BuilderUI.BuilderFieldContainer>
  );
};

export default SignificanceExperimentVariant;
